// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__VZ02M","buttons":"RemoveExpirationActionButtons_buttons__2bTv-"};